import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

import { primaryFactory } from 'src/services/themeColors';
import { IWithUserProps } from '../../services/withUser';
import NavLink from './components/NavLink';
import Submenu from './components/Submenu';
import { getAdminPages } from 'src/services/getAdminPages';
import logo from './datacroft-logo.svg';

const ParagraphPrimary = primaryFactory('p');
const SpanPrimary = primaryFactory('span');

interface IHeaderProps extends RouteComponentProps<any>, IWithUserProps {
  appName: string;
  appLogoSrc: string;
}

const Header: React.FC<IHeaderProps> = ({ user, appName, appLogoSrc }) => {
  const userAuthorized =
    user.roles && !(user.roles.length === 1 && user.roles[0] === '');
  const authorizedSubpages = getAdminPages(user.roles);
  const firstAuthorizedSubpage =
    authorizedSubpages.length !== 0 && authorizedSubpages[0];

  return (
    <header className="pt-16 text-xl">
      <div className="flex justify-between mb-16">
        <div>
          <img src={appLogoSrc || logo} alt={appName} />
          <ParagraphPrimary className="mt-3 text-2xl">
            {appName}
          </ParagraphPrimary>
        </div>
        <div className="text-right">
          {user.loggedIn ? (
            <>
              <p className="mb-2">
                Welcome, <SpanPrimary>{user.username}</SpanPrimary>
              </p>
              <NavLink to="/logout" className="mr-0">
                Log out
              </NavLink>
            </>
          ) : (
            <NavLink to="/login">Log in</NavLink>
          )}
        </div>
      </div>
      {user.loggedIn && (
        <nav className="text-center text-2xl mb-12">
          <ul className="list-reset flex justify-center">
            <li className="px-3">
              <NavLink to="/" exact={true} className="block">
                Existing Links
              </NavLink>
            </li>
            <Submenu label="Create New Links">
              <>
                <NavLink to="/link-create" submenu={true}>
                  Individual Link
                </NavLink>
                <NavLink to="/link-bulk-upload" submenu={true}>
                  Bulk Upload
                </NavLink>
              </>
            </Submenu>
            <li className="px-3">
              <NavLink to="/target-check" className="block">
                Target Check
              </NavLink>
            </li>
            <li className="px-3">
              <NavLink to="/tutorial" className="block">
                Tutorial
              </NavLink>
            </li>
            {userAuthorized && firstAuthorizedSubpage && (
              <li className="px-3">
                <NavLink
                  to={firstAuthorizedSubpage.path}
                  parent="/admin"
                  className="block"
                >
                  Admin Area
                </NavLink>
              </li>
            )}
          </ul>
        </nav>
      )}
    </header>
  );
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx